var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "detail" } },
    [
      _c("div", { staticClass: "header" }, [
        _c("div", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.$t("ticimax.automationRules"))),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "subtitle" }, [
          _vm._v(_vm._s(_vm.$t("ticimax.createAutomationDesc"))),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "toolbox" }, [
        _c("div", { staticClass: "left" }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "right" },
          [
            _c(
              "SupsisButton",
              {
                attrs: { primary: "" },
                on: {
                  click: function () {
                    return (_vm.createMode = true)
                  },
                },
              },
              [
                _c("a-icon", { attrs: { type: "plus" } }),
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("ticimax.createAutomationRule")) +
                    "\n            "
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _vm.createMode
        ? _c("CreateRule", {
            attrs: { channel: _vm.channel },
            on: {
              cancel: function () {
                return (_vm.createMode = false)
              },
              ok: _vm.onRuleAdded,
            },
          })
        : _c("ve-table", {
            staticStyle: { "word-break": "break-word" },
            style: {
              width: _vm.getMaxWidth() + "px",
            },
            attrs: {
              columns: _vm.getColumns(),
              "table-data": _vm.rules,
              "row-style-option": _vm.rowStyleOption,
              "cell-style-option": _vm.cellStyleOption,
              "border-x": true,
              "border-y": true,
              "expand-option": _vm.expandOption,
              "row-key-field-name": "_id",
              id: "automation-rules-table",
              "fixed-header": true,
            },
          }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }